import { useRemoteConfig } from '@funtech-int/yango-shared';

import { remoteConfigScheme } from '@/app/lib/remoteConfig';

const DEFAULT_HEADER_ITEMS = [] as string[];

export function useHeaderItems(): string[] {
    const remoteConfig = useRemoteConfig(remoteConfigScheme);

    return remoteConfig.get('header_items') ?? DEFAULT_HEADER_ITEMS;
}
